const BOOKING_BASE = '/t/public/booking';

async function parseJsonResponse(res) {
  let payload = null;
  try {
    payload = await res.json();
  } catch {
    payload = null;
  }
  return payload;
}

function fieldErrorsFromPayload(payload) {
  if (!payload || typeof payload !== 'object') return {};
  const next = {};
  Object.keys(payload).forEach(key => {
    const v = payload[key];
    if (Array.isArray(v) && v.length) next[key] = String(v[0]);
    else if (typeof v === 'string') next[key] = v;
  });
  return next;
}

export function bookingErrorMessage(payload, fallback = 'Something went wrong. Please try again.') {
  if (!payload || typeof payload !== 'object') return fallback;
  if (typeof payload.detail === 'string' && payload.detail) return payload.detail;
  if (typeof payload.token === 'string' && payload.token) return payload.token;
  const first = Object.values(payload).find(v => {
    if (Array.isArray(v) && v.length) return true;
    return typeof v === 'string' && v;
  });
  if (Array.isArray(first) && first.length) return String(first[0]);
  if (typeof first === 'string') return first;
  return fallback;
}

async function bookingFetch(path, { method = 'GET', body, query } = {}) {
  let url = `${BOOKING_BASE}${path}`;
  if (query) {
    const params = new URLSearchParams();
    Object.entries(query).forEach(([key, value]) => {
      if (value === undefined || value === null || value === '') return;
      params.set(key, String(value));
    });
    const qs = params.toString();
    if (qs) url = `${url}?${qs}`;
  }

  const options = {
    method,
    headers: { Accept: 'application/json' },
  };
  if (body !== undefined) {
    options.headers['Content-Type'] = 'application/json';
    options.body = JSON.stringify(body);
  }

  const res = await fetch(url, options);
  const payload = await parseJsonResponse(res);
  if (!res.ok) {
    const err = new Error(bookingErrorMessage(payload));
    err.status = res.status;
    err.payload = payload;
    err.fieldErrors = fieldErrorsFromPayload(payload);
    throw err;
  }
  return payload;
}

export function fetchAppointmentTypes() {
  return bookingFetch('/types/');
}

export function fetchDesigners() {
  return bookingFetch('/designers/');
}

export function fetchAvailability({ appointmentTypeId, designerId, from, to }) {
  return bookingFetch('/availability/', {
    query: {
      appointmentTypeId,
      designerId: designerId == null ? 'any' : designerId,
      from,
      to,
    },
  });
}

export function createAppointment(body) {
  return bookingFetch('/appointments/', { method: 'POST', body });
}

export function fetchActionSummary(token) {
  return bookingFetch('/actions/', { query: { token } });
}

export function confirmAppointment(token) {
  return bookingFetch('/actions/confirm/', { method: 'POST', body: { token } });
}

export function cancelAppointment(token) {
  return bookingFetch('/actions/cancel/', { method: 'POST', body: { token } });
}

export function fetchRescheduleAvailability({ token, from, to }) {
  return bookingFetch('/actions/reschedule/availability/', {
    query: { token, from, to },
  });
}

export function rescheduleAppointment({ token, startsAt }) {
  return bookingFetch('/actions/reschedule/', {
    method: 'POST',
    body: { token, startsAt },
  });
}
